export default defineNuxtRouteMiddleware((to, from) => {
	var excluded = ["_bam", "_eastern-polygon", "_trans-siberian-railway"];

	var name = to.name;

	if (name) {
		if (name.indexOf("_bam") == 0) {
			return navigateTo('/')
		}

		if (name.indexOf("_eastern") == 0) {
			return navigateTo('/')
		}

		if (name.indexOf("_transib") == 0) {
			return navigateTo('/')
		}
	}
})
